
import useUrlNavigation from 'hooks/useUrlNavigation';
import React, { useState } from 'react';
import { useLocation, Link } from 'react-router-dom';

const useInlinePageRouter = (defaultTab) => {
    const location = useLocation();
    const { urlQuery } = useUrlNavigation();
    const [activeTab, setActiveTab] = useState(defaultTab);
    const queryParams = new URLSearchParams(window.location.search);

    const InlineRouterTab = ({
        items,
        tabMode,
        defaultTab,
        useFullWidth,
        onTabChange,
        queryMode,
        containerClassName,
    }) => {
        return (
            <div
                className={`flex items-center bg-ep-gray-200 rounded-[10px] text-[14px] py-[0.5px] px-[4px] space-x-1 ${
                useFullWidth ? 'w-full justify-between' : 'w-max'
                } ${containerClassName}`}
            >
                {items.map(
                    ({ title, path, subRoute, value, queryName, queryValue, disabled, badge }, index) => {
                        if (tabMode === true) {
                            const isActive = activeTab === value || defaultTab === value;

                            return (
                                <div
                                    key={title}
                                    onClick={() => {
                                        if (!disabled) {
                                            setActiveTab(value);
                                            onTabChange && onTabChange(value);
                                        }
                                    }}
                                    className={`my-1 py-2 px-4 cursor-pointer font-medium flex items-center justify-center w-full whitespace-nowrap ${
                                        isActive
                                            ? 'bg-white text-ep-gray-700 shadow-md rounded-md'
                                            : 'text-ep-gray-500'
                                    } ${disabled ? 'cursor-not-allowed opacity-50' : ''}`}
                                >
                                    {title}
                                    {badge && (
                                        <span className="ml-2 bg-red-500 text-white text-xs rounded-full px-2 py-1">
                                            {badge}
                                        </span>
                                    )}
                                </div>
                            );
                        } else if (queryMode === true) {
                            const queryIsEmpty = !queryParams.has(queryName) || queryParams.get(queryName) === '';
                            const isActive = index === 0 ? queryIsEmpty : location?.search?.includes(queryValue);

                            return (
                                <div
                                    key={queryValue}
                                    className={`my-1 py-2 px-4 font-medium whitespace-nowrap  ${
                                        isActive
                                            ? 'bg-white text-ep-gray-700 shadow-md rounded-md'
                                            : 'text-ep-gray-500'
                                    }`}
                                >
                                    {disabled ?
                                    <button type='button'>
                                        {title}
                                        {badge && (
                                            <span className="ml-2 bg-ep-warning-50 text-ep-warning-700 text-xs rounded-full px-2 py-1">
                                                {badge}
                                            </span>
                                        )}
                                    </button> :
                                    <Link 
                                        to={urlQuery(`${queryName}=${queryValue}`)}
                                    >
                                        {title}
                                        {badge && (
                                            <span className="ml-2 bg-ep-warning-50 text-ep-warning-700 text-xs rounded-full px-2 py-1">
                                                {badge}
                                            </span>
                                        )}
                                    </Link>
                                    
                                    }
                                </div>
                            );
                        } else {
                            const isActive = location?.pathname === path;

                            return (
                                <div
                                    key={title}
                                    className={`my-1 py-2 px-4 font-medium whitespace-nowrap ${
                                        isActive
                                            ? 'bg-white text-ep-gray-700 shadow-md rounded-md'
                                            : 'text-ep-gray-500'
                                    }`}
                                >
                                    {disabled ?
                                    <button type='button'>
                                        {title}
                                        {badge && (
                                            <span className="ml-2 bg-ep-warning-50 text-ep-warning-700 text-xs rounded-full px-2 py-1">
                                                {badge}
                                            </span>
                                        )}
                                    </button> :
                                        <Link 
                                            to={path}
                                        >
                                        {title}
                                        {badge && (
                                            <span className="ml-2 bg-ep-warning-50 text-ep-warning-700 text-xs rounded-full px-2 py-1">
                                                {badge}
                                            </span>
                                        )}
                                    </Link>
                                    }
                                </div>
                            );
                        }
                    }
                )}
            </div>
        );
    };

    return { InlineRouterTab, activeTab, setActiveTab };
};

export default useInlinePageRouter;
